var errors = {};

function checkElement($this, cb) {
	if ($this.hasClass('error-check')) {
		var error = false,
			type = $this.attr('data-error'),
			val = $this.find('input, textarea, select').val(),
			notice = null;

		switch (type) {
			case "input":
				if (val.length < 1) {
					error = true;
				}
				break;
			case "textarea":
				if (val.length < 10) {
					error = true;
				}
				break;
			case "teeny_mce":
				if (typeof tinymce != 'undefined') {
					var name = $this.find('textarea').attr('name'),
						editor = tinyMCE.get(name),
						content = editor.getContent(),
						val = $($.parseHTML(content)).text();
					if (val.length < 10) {
						error = true;
					} else {
						editor.save();
					}
				}
				break;
			case "email":
				var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (re.test(val) == false) {
					error = true;
				}
				break;
			case "phone":
				var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
				if (re.test(val) == false) {
					error = true;
				}
				break;
			case "youtube":
				var re = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
				if (val != '' && !val.match(re)) {
					error = true;
				}
				break;
			case "password":
				if (val.length < 8) {
					error = true;
					notice = customData.errors.pwd_min_chars;
				} else if (val.length > 25) {
					error = true;
					notice = customData.errors.pwd_max_chars;
				}
				// else if (!(/[a-z]/.test(val))) {
				// 	error = true;
				// 	notice = customData.errors.pwd_min_lower;
				// } else if (!(/[A-Z]/.test(val))) {
				// 	error = true;
				// 	notice = customData.errors.pwd_min_upper;
				// } else if (!(/[0-9]/.test(val))) {
				// 	error = true;
				// 	notice = customData.errors.pwd_min_digit;
				// }
				break;
			case "repeat_password":
				if (val != $('.field[data-error="password"] input').val()) {
					error = true;
					notice = customData.errors.pwd_not_equal;
				}
				break;
			case "repeat_new_password":
				if (val != $('.field[data-error="new_password"] input').val()) {
					error = true;
					notice = customData.errors.pwd_not_equal;
				}
				break;
			case "select":
				if (val == null) {
					error = true;
				}
				break;
			case "select-conditional":
				if ($this.hasClass('is-active')) {
					if (val == null) {
						error = true;
					}
				}
				break;
			case "checkbox":
				var checked = false;
				$this.find('label').each(function () {
					if ($(this).hasClass('is-active')) {
						checked = true;
					}
				});
				if (checked == false) {
					error = true;
					notice = customData.errors.privacy;
				}
				break;
			case "radio":
				var checked = false;
				$this.find('input').each(function () {
					if ($(this).is(':checked')) {
						checked = true;
					}
				});
				if (checked == false) {
					error = true;
				}
				break;
			case "avatar":
				if (val == '') {
					error = true;
				}
				break;
			case "gallery":
				error = true;
				$this.find('input').each(function () {
					if ($(this).val() != '') {
						error = false;
					}
				});
				break;
			case "date":
				if (val == '') {
					error = true;
				} else {
					var date = val.split('-');
					date = new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0]));
					if (date == 'Invalid Date') {
						error = true;
					}
				}
				break;
			default:
				return;
		}

		if (error == true) {
			$this.addClass('has-error');
			if (notice == null) {
				notice = $this.find('.error').data('default');
			}
			$this.find('.error').html(notice);
		} else {
			$this.find('.error').html('');
			$this.removeClass('has-error');
		}
		if (typeof (cb) == 'function') {
			cb(error);
		}
	} else {
		if (typeof (cb) == 'function') {
			cb(error);
		}
	}
}

function checkElements($form, cb) {
	var error = false;
	$form.find('.error-check').each(function () {
		var $this = $(this);
		checkElement($this, function (err) {
			if (err == true) {
				//console.log('error for...', $this);
				error = true;
			}
		});
	});
	if (error == true) {
		formNotice($form, true);
	}
	if (typeof (cb) == 'function') {
		cb(error);
	}
}

function formNotice($form, error, show = true, notice, position = 'bottom') {
	let $notice = $form.find(`.form-notice-${position}`),
		$group = $form.find('.field-submit');

	//console.log($form, error, show, notice, position);

	if (show == true) {
		if (notice == false || typeof notice == 'undefined') {
			if (error == true) {
				notice = $notice.find('.error').data('default');
			} else {
				notice = $notice.find('.notice').data('default');
			}
		}
		if (position == 'top') {
			$notice.addClass('is-active');
			$notice.html(notice);
			if (error == true) {
				$notice.addClass('has-error').removeClass('has-success');
			} else {
				$notice.addClass('has-success').removeClass('has-error');
			}
		} else {
			if (error == true) {
				$group.addClass('has-error').removeClass('has-success');
				$notice.find('.error').html(notice);
			} else {
				$group.addClass('has-success').removeClass('has-error')
				$notice.find('.notice').html(notice);
			}
		}

	} else {
		$group.removeClass('has-error').removeClass('has-success');
		$notice.removeClass('is-active').removeClass('has-error').removeClass('has-success');
	}
}

errors.check = {
	form: function ($form, callback) {
		checkElements($form, function (error) {
			callback(error);
		});
	},
	el: function ($this) {
		checkElement($this);
	},
	elPHP: function ($this, notice = false) {
		$this.addClass('has-error');
		if (notice == false) {
			notice = $this.find('.error').data('default');
		}
		$this.find('.error').html(notice);
	},
}

errors.formNotice = function ($form, error, show = true, notice, position = 'bottom') {
	formNotice($form, error, show, notice, position);
}

export { errors };
